import authRoutes from "./routes/auth.routes";
import businessRoutes from "./routes/business.routes";

// Velzon theme demo routes (UI kit / icon gallery / charts / forms / blogs /
// pages / advance-ui / auth variants / maps). They are not linked from the
// menu and not part of the product. To re-enable, import "./routes/demo.routes"
// and spread it below.

export default [
  ...authRoutes,
  ...businessRoutes,
];
